import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    value: null,
};

export const crmParamDetails = createSlice({
    name: 'crmparam',
    initialState,
    reducers: {
        crmParamDetail: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { crmParamDetail } = crmParamDetails.actions;

export default crmParamDetails.reducer;